// extracted by mini-css-extract-plugin
export var animationContainer = "_e0-0";
export var asteriskIcon = "_e0-8";
export var conversationLeftSection = "_e0-4";
export var conversationListItem = "_e0-3";
export var conversationMiddleSection = "_e0-5";
export var conversationRightSection = "_e0-6";
export var detailsContent = "_e0-1";
export var listContainer = "_e0-7";
export var modalContent = "_e0-2";